<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">ข้อมูล Detail</h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row v-if="isLoadingData">
          <b-col class="px-4 px-sm-5 py-4 vh-100">
            <img src="/img/loading.svg" class="loading" alt="loading" />
          </b-col>
        </b-row>
        <div>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="Main Keyword"
                placeholder="Main Keyword"
                type="text"
                name="mainKeyword"
                isRequired
                v-model="form.mainKeyword"
                :isValidate="$v.form.mainKeyword.$error"
                :v="$v.form.mainKeyword"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="font-weight-bold main-label">
                สถานะ
                <span class="text-danger">*</span>
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isActive"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isActive ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div>
                <b-input-group class="mb-2">
                  <b-form-input
                    v-model="newTag"
                    placeholder="New tag - Press enter to add"
                    class="form-control"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addTag()" variant="primary">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
                <div class="d-inline-block" style="font-size: 1.5rem">
                  <b-form-tag
                    v-for="(tag, idx) in form.formatAlternativeKeywords"
                    @remove="removeTag(tag, idx)"
                    :key="idx"
                    :title="tag.keyword"
                    class="mr-1"
                  >
                    {{ tag.keyword }}
                  </b-form-tag>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col md="6">
              <b-button
                :disabled="isDisable"
                @click="cancleHandler"
                class="btn-details-set btn-cancel"
                >CANCEL</b-button
              >
            </b-col>
            <b-col md="6" class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);

const alpha = helpers.regex("alpha", /^[\u0E00-\u0E7Fa-zA-Z']*$/);

import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading
  },
  data() {
    return {
      isLoadingData: false,
      modalMessage: "",
      isDisable: false,
      id: this.$route.params.id,
      redirecId: 0,
      form: {
        id: 0,
        mainKeyword: "",
        formatAlternativeKeywords: [],
        formatIdAlternativeKeywordsDeleted: [],
        isActive: 1,
      },
      newTag: ""
    };
  },
  validations: {
    form: {
      mainKeyword: { required },
    }
  },
  created: async function () {
    this.getDatas();
  },
  methods: {
    isAlphabet: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 65 && charCode < 91) {
        return true;
      } else if (charCode > 96 && charCode < 123) {
        return true;
      } else if (charCode > 160 && charCode < 238) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    hadleModalAlertClose() {
      this.$router.push({
        path: `/format-keyword`
      });
    },
    cancleHandler() {
      this.$router.push({ name: "Format Keyword" });
    },
    getDatas: async function () {
      if (this.id !== "0") {
        this.isLoadingData = true;
        await this.axios
          .get(`${this.$baseUrl}/formatkeyword/${this.id}`)
          .then(res => {
            if (res.data.result == 1) {
              this.form = { ...this.form, ...res.data.detail };
              this.isLoadingData = false;
            }
          });
      } else {
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/formatkeyword`, this.form)
        .then(res => {
          if (res.data.result == 1) {
            this.redirecId = res.data.detail.id;
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = res.data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
    addTag() {
      if (this.newTag.trim() !== "") {
        const newTag = {
          id: 0,
          formatMainKeywordId: parseInt(this.$route.params.id),
          keyword: this.newTag.trim()
        };
        this.form.formatAlternativeKeywords.push(newTag);
        this.newTag = ""; // Clear the input field after adding the tag
      }
    },
    removeTag(tagToRemove, idx) {
      if (tagToRemove.id) {
        this.form.formatIdAlternativeKeywordsDeleted.push(tagToRemove.id);
      }
      this.form.formatAlternativeKeywords.splice(idx, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-reset-password {
  background-color: #7160c4;
  color: white;
}
</style>
